module.exports = __webpack_public_path__ + "img/admin_adv_16.f5b43074.png";